import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=814fdf4a&scoped=true&"
import script from "./Number.ts?vue&type=script&lang=ts&"
export * from "./Number.ts?vue&type=script&lang=ts&"
import style0 from "./Number.css?vue&type=style&index=0&id=814fdf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814fdf4a",
  null
  
)

export default component.exports